<template>
  <div>
    <a-modal v-if="userInfo.feeFlag == 0 && examData.examMode == 2" v-model:open="localExamMode" :title="modalTitle" width="50%" :footer="null">
      <div class="modal_content">
        <ul class="ul_content">
          <div v-html="content1"></div>
        </ul>
        <ul class="ul_title">
          1.线上考试:
          <img src="@/assets/images/exam1.png" height="14px" />
          <a class="_bgcolor" style="text-decoration: underline;" @click="goOpen">去开通</a>
        </ul>

        <!--        <ul  style="
          margin-top: 10px;
          color: #0E559F;
        ">
          <p class="_bgcolor">开通线上考试服务：<img src="@/assets/images/exam1.png" height="14px"/>
          <a style="text-decoration: underline;" @click="goOpen">去开通</a></p>
        </ul>-->
        <ul class="ul_title" style="margin-top: 20px">
          2.线下考试:
          <img src="@/assets/images/exam1.png" height="14px" />
          <a class="_bgcolor" style="text-decoration: underline;" @click="goApply">去预约</a>
        </ul>
        <ul>
          <div v-html="content3"></div>
        </ul>
        <!--        <ul style="
          margin-top: 10px;
          color: #0E559F;
        ">
          <img src="@/assets/images/exam1.png" height="14px"/>
          <a class="_bgcolor"  style="text-decoration: underline;" @click="goApply">预约线下考试</a>
        </ul>-->
      </div>
    </a-modal>
    <a-modal v-if="userInfo.feeFlag == 1 || examData.examMode == 1" v-model:open="localExamMode" :title="modalTitle" width="50%">
      <div class="modal_content">
        <ul class="ul_content">
          <div v-html="content2"></div>
        </ul>
      </div>
      <template #footer>
        <div class="footer-container">
          <a type="primary" @click="handleOk" :disabled="countDown > 0" :style="buttonStyle">
            已阅读并确认
            <span v-if="countDown > 0" class="count-down">({{ countDown }}s)</span>
          </a>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: ['examMode', 'examData'],
  data: function() {
    return {
      userInfo: { feeFlag: '' },
      modalTitle: '',
      countDown: 5, // 倒计时初始值
      timer: null,
      localExamMode: this.examMode,
      content1: '', //考试选择须知
      content2: '', //线上考试须知
      content3: '', //线下考试须知
    };
  },
  computed: {
    buttonStyle() {
      let $bgColor;
      return {
        color: this.countDown <= 0 ? $bgColor : '',
      };
    },
  },
  watch: {
    // 监听父组件传递的prop变化，同步到本地状态
    examMode(newVal) {
      this.localExamMode = newVal;
    },
    // 监听本地状态变化，通知父组件更新
    localExamMode(newVal) {
      // 当本地状态变化时，通过事件通知父组件
      this.$emit('update:examMode', newVal);

      // 保持原有的倒计时逻辑
      if (newVal) {
        this.countDown = 5;
        this.startCountDown();
      } else {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    },
  },
  methods: {

    // 添加处理HTML内容的方法
    normalizeHtmlContent(html) {
      if (!html) return '';
      
      let normalized = html
        // 处理删除线标签，使用内联样式确保效果
        .replace(/<s([^>]*)>(.*?)<\/s>/g, '<span style="text-decoration: line-through;">$2</span>')
        // 处理加粗标签，确保正确闭合且不被破坏
        .replace(/<strong([^>]*)>(.*?)<\/strong>/g, '<strong$1>$2</strong>')
        // 处理可能的嵌套情况：先加粗后删除线
        .replace(/<strong([^>]*)><s([^>]*)>(.*?)<\/s><\/strong>/g, 
          '<strong$1><span style="text-decoration: line-through;">$3</span></strong>')
        // 处理可能的嵌套情况：先删除线后加粗
        .replace(/<s([^>]*)><strong([^>]*)>(.*?)<\/strong><\/s>/g, 
          '<span style="text-decoration: line-through;"><strong$2>$3</strong></span>')
        // 移除pre标签
        .replace(/<\/?pre[^>]*>/g, '')
        // 替换换行符为br标签
        .replace(/\n/g, '<br>');
        
      return normalized;
    },
    goOpen(){
      this.$router.push("/personalcenters/payment");
    },
    goApply() {
      this.$router.push('/personalcenters/applyOfflineExam');
    },
    handleOk() {
      this.$parent.startExam(null, this.examData.viewCode, 1, null);
      this.localExamMode = false;
    },
    startCountDown() {
      // 清除可能存在的旧定时器
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        this.countDown--;
        if (this.countDown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
  },
  created() {
    this.axios.get('/biz/archive/info').then(res => {
      this.userInfo = res.result;
      if (this.userInfo.feeFlag == 0 && this.examData.examMode == 2) {
        this.modalTitle = '考试选择';
      } else {
        this.modalTitle = '考试须知';
      }
    })
    this.axios.get('/exam/eduExamExplanation/getExamExplanationData?source=pc').then((res) => {
      this.content1 = this.normalizeHtmlContent(res.result.content1)
      this.content2 = this.normalizeHtmlContent(res.result.content2)
      this.content3 = this.normalizeHtmlContent(res.result.content3)
    })
    this.startCountDown()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl';
.modal_content{
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #333333;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.ul_title{
  font-weight: bold;
}
.footer-container {
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
._bgcolor{
  color: $bgColor;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/modal/SelectExamMode.vue